import {
  DOWNLOAD_APPLICANT_DOCUMENT,
  DOWNLOAD_APPLICANT_ZIP_DOCUMENT,
} from 'redux/actionTypes';

const initialState = {};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case DOWNLOAD_APPLICANT_DOCUMENT:
      return { ...state, applicantDocument: payload };
    case DOWNLOAD_APPLICANT_ZIP_DOCUMENT:
      return { ...state, applicantZipDocument: payload };
    default:
      return state;
  }
};
